import React from "react";
import {withStyles} from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import {NotificationContainer, NotificationManager} from "react-notifications";
import {
    communicationPlan,
    communicationPlanRevision, deleteCommunicationPlan,
    saveOrUpdateCommunicationPlan
} from "../../util/CommunicationPlanModuleApiUtils";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import {AddCircleOutlineTwoTone} from "@material-ui/icons";
import moment from "moment";
import CardContent from "@material-ui/core/CardContent";
import Modal from "@material-ui/core/Modal";
import CommunicationPlanRevisionModal from "./CommunicationPlanRevisionModal";
import {BlueButton} from "../common/ButtonsConstants";
import MuiTable from "../common/MuiTable";
import {Spinner} from "../common/Spinner";
import {exportReport} from "../../util/ApiUtils";
import * as CommonUtils from "../../util/CommonUtils";

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
}));

const columns = [
    {
        title: 'What needs to be communicated',
        field: 'what',
        type: "textarea",
    },
    {
        title: 'When to communicate',
        field: 'when',
        type: "textarea",
    },
    {
        title: 'With whom to communicate',
        field: 'withWhom',
        type: "textarea",
    },
    {
        title: 'How to communicate',
        field: 'how',
        type: "textarea",
    },
    {
        title: 'Who communicates',
        field: 'who',
        type: "textarea",
    },
];

class CommunicationPlan extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            isLoading: true,
            show: false,
            latestRevision: {}
        };
        this.loadCommunicationPlan = this.loadCommunicationPlan.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleAddRow = this.handleAddRow.bind(this);
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentDidMount() {
        this.loadCommunicationPlan();
    }

    showModal() {
        this.setState({
            show: true
        });
    }

    closeModal(updatedRevision) {
        if (updatedRevision) {
            this.setState({
                show: false,
                latestRevision: updatedRevision,
            });
        } else {
            this.setState({
                show: false,
            });
        }
    }

    loadCommunicationPlan() {
        communicationPlan()
            .then(response => {
                console.log('loaded', response);
                this.setState({
                    data: response,
                });
                communicationPlanRevision()
                    .then( revisionResponse => {
                        this.setState({
                            latestRevision: revisionResponse,
                            isLoading: false,
                        });
                    })
                    .catch(error => {
                        console.log(error);
                    });
            })
            .catch(error => {
                console.log(error);
            });
    }

    handleDelete(data) {
        console.log('delete', data);
        deleteCommunicationPlan(data)
            .then(() => {
                this.loadCommunicationPlan();
                NotificationManager.success('Success', 'The Communication Plan has been updated.', 5000);
            }).catch(
            error => {
                console.log("error");
                console.log(error);
                NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
            });
    }

    isValid(newData) {
        /*let isValid = newData.name && newData.name !== '' && newData.description && newData.description !== '';
        if (!isValid) {
            NotificationManager.error('Error', 'Validation Error. Name and Description are required fields', 5000);
        }
        return isValid;*/
        // for now its always valid
        return true;
    }

    handleAddRow() {
        this.state.data.push({
            immutable: false,
        });
        console.log('pushed', this.state.data);
        this.setState({ state: this.state });
    }

    handleSubmit(data) {
        saveOrUpdateCommunicationPlan(data)
            .then(() => {
                this.loadCommunicationPlan();
                NotificationManager.success('Success', 'The Communication Plan has been updated.', 5000);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    render() {
        const { state } = this;

        if (state.isLoading) {
            return <Spinner/>;
        }

        const isRevision = state.latestRevision.completedBy && state.latestRevision.completedOn;
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        return <div>
            <Typography component="h2" variant="h5">
                COMMUNICATION PLAN
            </Typography>
            <Paper className={classes.root} style={{ marginTop: '30px' }}>
                <Card className={classes.card}>
                    <CardHeader
                        action={
                            <BlueButton
                                variant="contained"
                                color="secondary"
                                startIcon={<AddCircleOutlineTwoTone/>}
                                onClick={this.showModal}
                                size="small"
                                style={{marginRight: '10px'}}
                                disabled={isAuditor}
                            >
                                ADD
                            </BlueButton>
                        }
                        title={
                            (isRevision &&
                                (<span style={{color: "darkblue"}}>
                                    <p>
                                        <b><span>REVISION {state.latestRevision.number}: {moment(state.latestRevision.date).format('DD/MM/YYYY')}</span></b>
                                    </p>
                                </span>)
                            )
                        }
                        subheader={
                            isRevision &&
                            <span>
                                <p>Plan completed by: {state.latestRevision.completedBy}</p>
                                <p>Date: {moment(state.latestRevision.completedOn).format('DD/MM/YYYY')}</p>
                            </span>
                        }
                    />
                    <CardContent>
                        <MuiTable
                            title="Communication Plan"
                            columns={columns}
                            data={state.data}
                            onAdd={this.handleSubmit}
                            onUpdate={this.handleSubmit}
                            onDelete={this.handleDelete}
                            exportButton={!isDemo}
                            onExport={() => exportReport('/communication-plan/export')}
                            isValid={this.isValid}
                            pageSize={10}
                            allowUpdateDelete={isAuditor ? 'no' : 'yes'}
                        />
                    </CardContent>
                </Card>
            </Paper>
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={state.show}
                onClose={() => this.closeModal(null)}
            >
                <CommunicationPlanRevisionModal latestRevisionDto={state.latestRevision} postSubmit={this.closeModal}/>
            </Modal>
            <NotificationContainer/>
        </div>;
    }
}

export default withStyles(classes)(CommunicationPlan);